<template>
  <a
    :href="resolvedHref"
    class="layer-link"
    @click="handleClick">
    <slot>{{ text }}</slot>
  </a>
</template>

<script>
export default {
  name: 'layer-link',

  props: {
    layerName: {
      type: String,
      required: true
    },
    params: {
      type: Object,
      default: () => ({})
    },
    text: {
      type: String,
      default: 'View'
    }
  },

  computed: {
    resolvedHref () {
      const resolved = this.$router.resolve({ name: this.layerName, params: this.params })
      return resolved.href
    }
  },

  methods: {
    handleClick (event) {
      // Honor cmd-click / ctrl-click / shift-click / middle-click — let the browser open a new tab
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.button === 1) return
      event.preventDefault()
      this.$router.push({ name: this.layerName, params: this.params })
    }
  }
}
</script>
